// extracted by mini-css-extract-plugin
export default {"small":"576px","medium":"768px","large":"992px","xLarge":"1200px","xxLarge":"1600px"};